/** 设置页面相关接口 */
import request from '@/utils/util.request';

/*
 *  (setting) 加载setting参数
 */
export const setting_load_data = (data) => {
	return request({
		url: '/setting/loaddata',
		data,
	});
};

/*
 *  (setting) 保存setting参数修改
 */
export const setting_edit = (data) => {
	return request({
		url: '/setting/edit',
		data,
	});
};

/*
 *  (setting) 设备运行检测
 */
export const examine_device = (data) => {
	return request({
		url: '/setting/examinedevice',
		data,
	});
};

/*
 *  (icon) 图库加载
 */
export const icon_load_data = (data) => {
	return request({
		url: '/icon/loaddata',
		data,
	});
};

/*
 *  (icon) 选择图标
 * @param {int} id:
 */
export const icon_save = (data) => {
	return request({
		url: '/icon/save',
		data,
	});
};
